/* HBJ: <hbj-sticky-atc> — sticky koopbalk op de PDP.
   - Verschijnt zodra het hoofdformulier (product-form) boven het scherm uit is
     gescrold, op mobiel én desktop; verdwijnt onderaan de pagina (footer).
     Bewust géén IntersectionObserver: bij een sprong-scroll (ankerlink, snelle
     fling) passeert het formulier zonder overgang en vuurt die niet. Daarom een
     rAF-gethrottlede scroll/resize-check op getBoundingClientRect().
   - De knop verstuurt het hoofdformulier (requestSubmit) zodat product-form.js
     de toevoeging afhandelt (drawer/redirect volgens theme-setting).
   - Spiegelt de staat van de hoofdknop: tekst, uitverkocht, "Maak een selectie"
     (dan scrollt de knop naar de variantkiezer) en de laadstatus.
   - Zet body.hbj-sticky-atc-visible zodat hbj-chat.css de Inbox-knop verbergt. Het element wordt bij een variantwissel opnieuw gerenderd
     (data-dynamic-variant-content), daarom alles in connected/disconnected. */
if (!customElements.get('hbj-sticky-atc')) {
  class HbjStickyAtc extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.cc-main-product');
      this.btn = this.querySelector('.hbj-sticky-atc__btn');
      this.label = this.querySelector('.hbj-sticky-atc__btn-label');
      this.onClick = this.handleClick.bind(this);
      this.onScroll = this.handleScroll.bind(this);
      this.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.onScroll, { passive: true });

      this.onResize = this.handleScroll.bind(this);
      window.addEventListener('resize', this.onResize, { passive: true });
      if (this.section && 'MutationObserver' in window) {
        this.mo = new MutationObserver(() => {
          clearTimeout(this.syncTimer);
          this.syncTimer = setTimeout(() => this.syncState(), 60);
        });
        this.mo.observe(this.section, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'class', 'aria-disabled'] });
      }
      this.syncState();
      this.handleScroll();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      if (this.mo) this.mo.disconnect();
      document.body.classList.remove('hbj-sticky-atc-visible');
    }

    getForm() {
      return this.section ? this.section.querySelector('form.js-product-form-main') : null;
    }

    getMainBtn() {
      const form = this.getForm();
      return form ? form.querySelector('[name="add"]') : null;
    }

    setOut(out) {
      this.classList.toggle('hbj-sticky-atc--out', out);
      document.body.classList.toggle('hbj-sticky-atc-visible', !out && !document.body.classList.contains('scrolled-to-bottom'));
    }

    handleScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.ticking = false;
        const form = this.getForm();
        // "out" zolang de onderkant van het formulier nog in/onder beeld is
        if (form) this.setOut(form.getBoundingClientRect().bottom > 0);
        const atBottom = window.scrollY + window.innerHeight + 100 > document.body.scrollHeight;
        document.body.classList.toggle('scrolled-to-bottom', atBottom);
        if (atBottom) document.body.classList.remove('hbj-sticky-atc-visible');
        else if (!this.classList.contains('hbj-sticky-atc--out')) document.body.classList.add('hbj-sticky-atc-visible');

      });
    }

    syncState() {
      const main = this.getMainBtn();
      if (!main || !this.btn) return;
      const text = (main.textContent || '').trim();
      if (this.label && text) this.label.textContent = text;
      const soldOut = main.disabled && text === (window.theme && theme.strings && theme.strings.noStock);
      this.btn.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
      this.btn.classList.toggle('is-loading', main.classList.contains('is-loading'));
      this.btn.dataset.needsSelection = main.disabled && !soldOut ? 'true' : 'false';
    }

    handleClick(evt) {
      const btn = evt.target.closest('.hbj-sticky-atc__btn');
      if (!btn) return;
      evt.preventDefault();
      const form = this.getForm();
      const main = this.getMainBtn();
      if (!form || !main) return;
      if (main.disabled || btn.dataset.needsSelection === 'true') {
        const anchor = document.getElementById('variants') || form;
        anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (typeof form.requestSubmit === 'function') form.requestSubmit(main);
      else main.click();
    }
  }
  customElements.define('hbj-sticky-atc', HbjStickyAtc);
}
